import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PWAThunk } from 'lib/core/data'
import { MagentoStoreConfig } from 'lib/types'
import { localStorage } from 'lib/core/services/localStorage'
import { Slice } from './types'
import qs from 'qs'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: undefined
}

const slice = createSlice({
  name: 'common/storeConfig',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<MagentoStoreConfig>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchStoreConfig (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().common.fetchStoreConfig()
      const { data } = response
      const { storeConfig } = data
      if (storeConfig) {
        dispatch(success(storeConfig))
      } else {
        dispatch(failure())
      }
      return response
    } catch (e) {
      if (!handleWrongStoreViewAndRetry()) {
        dispatch(failure())
      }
    }
  }
}

const handleWrongStoreViewAndRetry = () => {
  const storeView = localStorage.get('storeView')
  const storeViewDefined = Boolean(storeView)
  if (storeViewDefined) {
    const { origin, pathname } = window.location
    const queryStringParams = qs.parse(window.location.search.substring(1))
    queryStringParams.storeView = undefined
    const queryString = qs.stringify(queryStringParams)
    localStorage.remove('storeView')
    window.location.href = `${origin}${pathname}${queryString ? `?${queryString}` : ''}`
  }

  return storeViewDefined
}
